<template>

<div>
  <b-alert
    :show="showAlert"
    @dismissed='showAlert = false'
    dismissible
    fade
    variant="success"
  >
    Comando enviado com sucesso!
  </b-alert>

  <div class="row">
    <div class="form-group col-lg-6">
      <label for="serial">{{ $t('serial') }}</label>
      <input
        type="text"
        id="serial"
        name="serial"
        class="form-control"
        :placeholder="$t('ph_serial')"
        v-model="serial"
      >
    </div>

    <div class="form-group col-lg-6">
      <label for="board">{{ $t('board') }}</label>
      <input
        type="text"
        id="board"
        name="board"
        class="form-control"
        :placeholder="$t('ph_board')"
        :value="board"
        @input="event => board = event.target.value.toUpperCase()"
        v-validate="'max:8|regex:[A-Z]{3}-{1}[0-9]{1}[0-9A-Z]{1}[0-9]{2}'"
        maxlength="8"
      >
    </div>
  </div>

  <LoaderButton
    id="search"
    @click="getLastPosition"
  >
    {{ $t('search') }}
  </LoaderButton>

  <div class="row">
    <div class="col-12">
      <b-table
        responsive='xl'
        bordered
        hover
        class="bg-white"
        :items="lastPosition"
        :fields='fieldsLastPositions'
      >
        <template v-slot:cell(newOffset)>
          <input
            type="text"
            id="newOffset"
            name="newOffset"
            class="form-control text-right"
            :placeholder="$t('ph_newOffset')"
            v-model="newOffset"
          >
        </template>

        <template v-slot:cell(vehicleId)=value>
          <div style="width: 180px" class="text-center">
            <b-button
              variant='primary'
              pill
              @click="setOffset(value.item.vehicleId)"
              class="mr-1"
              size="sm"
            >
              <i class="fas fa-satellite-dish" />
            </b-button>

            <b-button
              variant='primary'
              pill
              data-target="#modalConfirmChangeIP"
              data-toggle="modal"
              @click="vehicleId = value.item.vehicleId"
              class="mr-1"
              size="sm"
            >
              IP
            </b-button>

            <b-button
              :variant='value.item.mxt_ld ? "danger" : "primary"'
              pill
              @click="setMxtLdAndOffset"
              size='sm'
            >
              GWLD
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
  </div>

  <!-- MODAL CONFIRM CHANGE IP -->
  <div class="modal fade" id="modalConfirmChangeIP" tabindex="-1" role="dialog" aria-labelledby="modalConfirmChangeIPLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalConfirmChangeIPLabel">Alterar IP's</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h3 id="msgConfirmOs">Deseja enviar o comando para alterar o IP Primário e Secundário para 107.22.49.191:9002?</h3>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t('close') }}</button>
          <button type="button" class="btn btn-primary" @click="setIP" data-dismiss="modal">{{ $t('send') }}</button>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import LoaderButton from '@/components/button/LoaderButton'
import moment from 'moment-timezone'
import { request } from '@/lib/http'

export default {
  name: 'PositionsAndOffset',
  components: {
    LoaderButton
  },

  data () {
    return {
      serial: '',
      board: '',
      fieldsLastPositions: [
        {
          key: 'timestamp',
          label: this.$t('server_hour'),
          formatter: (value, key, item) => {            
            return value
              ? moment(value).tz('America/Recife').add(3, 'hours').format('DD/MM/YYYY HH:mm:ss')
              : ''
          }
        },
        {
          key: 'datetime',
          label: this.$t('gps_hour'),
          formatter: (value, key, item) => {            
            return value
              ? moment(value).tz('America/Recife').format('DD/MM/YYYY HH:mm:ss')
              : ''
          }
        },
        {
          key: 'gprs',
          label: 'GPRS',
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'gps',
          label: 'GPS',
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'latitude',
          label: this.$t('lat/lon'),
          formatter: (value, key, item) => {
            return value
              ? value + '/' + item.longitude
              : ''
          }
        },
        {
          key: 'id',
          label: this.$t('difference'),
          formatter: (value, key, item) => {
            const date = moment(item.datetime)
            const now = moment().format('YYYY-MM-DD HH:mm:ss')
            const difference = date.diff(now, 'seconds')

            const tempTime = moment.duration(difference, 'seconds')

            const year    = tempTime.years() > 0 ? tempTime.years() + ' ano(s), ' : ''
            const month   = tempTime.months() > 0 ? tempTime.months() + ' mes(es), ' : ''
            const day     = tempTime.days() > 0 ? tempTime.days() + ' dia(s), ' : ''
            const hour    = tempTime.hours() > 0 ? tempTime.hours() + ' hora(s), ' : ''
            const minutes = tempTime.minutes() > 0 ? tempTime.minutes() + ' minuto(s), ' : ''
            const second  = tempTime.seconds() > 0 ? tempTime.seconds() + ' segundo(s)' : ''

            return year + month + day + hour + minutes + second
          }
        },
        {
          key      : 'mxt_ld',
          label    : 'GW Locadados',
          formatter: value => value ? 'SIM' : 'NÃO'
        },
        {
          key: 'offset',
          label: this.$t('Offset')
        },
        {
          key: 'newOffset',
          label: 'Novo Offset'
        },
        {
          key: 'vehicleId',
          label: ''
        }
      ],
      lastPosition: [],
      newOffset: undefined,
      vehicleId: undefined,
      showAlert: false
    }
  },

  watch: {
    board: function(value) {
      // Define máscara da placa
      if (window.event.inputType === 'deleteContentBackward') {
        return
      }

      if (value.length === 3){
        this.board = value + '-'
      }

      if (value.length === 4 && !value.includes('-')) {
        this.board = value.substr(0,3)+"-"+value.substr(3)
      }
    },

    lastPosition: function(value) {
      this.newOffset = value.length > 0
        ? value[0].newOffset
        : undefined
    }
  },

  methods: {
    async getLastPosition() {
      const { dispatch } = this.$store

      if (!this.serial && !this.board) {
        return dispatch('notify/error', { message: 'É necessário informar o serial ou placa do veículo' })
      }

      dispatch('overlay/show', true)

      let params = {}
      if (this.serial) {
        params.serial = this.serial
      }
      if (this.board) {
        params.board = this.board
      }

      const { rows } = await request({
        url   : 'vehicledata',
        method: 'get',
        params
      })

      if (rows.length === 0) {
        this.lastPosition = []

        dispatch('overlay/show', false)

        return dispatch('notify/error', { message: 'Veículo não encontrado!' })
      }

      try {
        const position = await request({
          url   : 'position-and-offset',
          method: 'get',
          params: { vehicleId: rows[0].VEI_ID }
        })

        if (position.length > 0) {
          const last = []
          last.push(position[0])
    
          this.lastPosition = last
        } else {
          this.lastPosition = []
        }
      } catch (error) {}

      dispatch('overlay/show', false)
    },

    async setOffset(vehicleId) {
      const { dispatch } = this.$store

      dispatch('overlay/show', true)

      try {
        await request({
          url   : `position-and-offset/${vehicleId}`,
          method: 'patch',
          params: { newOffset: this.newOffset }
        })

      } catch (error) {
        console.log(error)
      } finally {
        dispatch('overlay/show', false)
        $('#search').trigger('click')
      }

    },

    async setIP() {
      const { dispatch } = this.$store

      dispatch('overlay/show', true)

      try {
        await request({
          url   : `command-change-ip/${this.vehicleId}`,
          method: 'patch'
        })

        this.showAlert = true
      } catch (error) {
        dispatch('notify/error', { message: error.message })
      } finally {
        dispatch('overlay/show', false)
        $('#modalConfirmChangeIP').modal('hide')
      }
    },

    async setMxtLdAndOffset() {
      const { dispatch }          = this.$store
      const { vehicleId, mxt_ld } = this.lastPosition[0]

      dispatch('overlay/show', true)

      try {
        await request({
          url   : `set-mxt-ld/${vehicleId}`,
          method: 'patch',
          params: {
            mxt_ld: mxt_ld == 1 ? 0 : 1
          }
        })
        
        await this.getLastPosition()
      } catch (error) {
        dispatch('notify/error', { message: error.message })
      } finally {
        dispatch('overlay/show', false)
      }
    }
  },
}
</script>